import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'ngx-doc-form-dropdown',
  templateUrl: './doc-form-dropdown.component.html',
  styleUrls: ['./doc-form-dropdown.component.scss'],
})
export class DocFormDropdownComponent implements OnChanges {
  @Input() options: any[];
  @Input() displayField: string = 'name';
  @Input() keyField: string = 'id';
  @Input() disabled: boolean = false;
  @Input() styles: any;
  @Input() value: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private cdRef: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options?.currentValue && !changes.options.isFirstChange()) {
      // hack to show correct value after updating options
      const tmp = this.value;
      this.value = ''
      this.cdRef.detectChanges();
      this.value = tmp;
      this.cdRef.detectChanges();
    }
  }

  updateValue(event) {
    if (event === 'null') event = null;
    if (event === 'undefined') event = undefined;
    this.valueChange.emit(event);
  }


}
